import React from "react";
import {
  CalendarDays,
  MessageCircle,
  Dumbbell,
  ShoppingCart,
  Users,
} from "lucide-react";

interface MobileFrameProps {
  children: React.ReactNode;
  brandColor: string;
  showBottomNavigation?: boolean;
}

const MobileFrame: React.FC<MobileFrameProps> = ({
  children,
  brandColor,
  showBottomNavigation = false,
}) => {
  return (
    <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-p-8">
      {/* Phone Frame */}
      <div className="tw-relative tw-bg-black tw-rounded-[2.5rem] tw-p-2 tw-shadow-2xl tw-w-[min(400px,calc(80vh*9/19.5))] tw-h-[min(80vh,calc(400px*19.5/9))] tw-aspect-[9/19.5]">
        {/* Screen */}
        <div className="tw-bg-white tw-rounded-[2rem] tw-overflow-hidden tw-relative tw-w-full tw-h-full">
          {/* Status Bar */}
          <div
            className="tw-h-6 tw-flex tw-items-center tw-justify-between tw-px-6 tw-text-white tw-text-xs tw-flex-shrink-0"
            style={{
              backgroundColor: brandColor,
            }}
          >
            <span>9:41</span>
            <div className="tw-flex tw-items-center tw-space-x-1">
              <div className="tw-flex tw-space-x-1">
                <div className="tw-w-1 tw-h-1 tw-bg-white tw-rounded-full"></div>
                <div className="tw-w-1 tw-h-1 tw-bg-white tw-rounded-full"></div>
                <div className="tw-w-1 tw-h-1 tw-bg-white tw-rounded-full"></div>
                <div className="tw-w-1 tw-h-1 tw-bg-gray-500 tw-rounded-full"></div>
              </div>
              <div className="tw-w-6 tw-h-3 tw-border tw-border-white tw-rounded-sm tw-ml-1">
                <div className="tw-w-4 tw-h-2 tw-bg-white tw-rounded-sm tw-m-0.5"></div>
              </div>
            </div>
          </div>

          {/* App Content */}
          <div
            className="tw-flex-1 tw-overflow-hidden tw-flex tw-flex-col"
            style={{ height: "calc(100% - 1.5rem)" }}
          >
            <div
              className="tw-flex-1 tw-overflow-hidden"
              style={{
                height: showBottomNavigation ? "calc(100% - 80px)" : "100%",
              }}
            >
              {children}
            </div>

            {/* Bottom Navigation */}
            {showBottomNavigation && (
              <div className="tw-h-20 tw-flex tw-items-center tw-justify-around tw-px-2">
                {[
                  { name: "Schedule", icon: CalendarDays, active: true },
                  { name: "Chat", icon: MessageCircle, badge: "5" },
                  { name: "Workouts", icon: Dumbbell },
                  { name: "Products", icon: ShoppingCart },
                  { name: "People", icon: Users },
                ].map((tab) => (
                  <div
                    key={tab.name}
                    className="tw-flex tw-flex-col tw-items-center tw-relative"
                  >
                    <div className="tw-relative">
                      <tab.icon
                        className="tw-text-xl tw-mb-1 tw-text-neutral-600"
                        style={{
                          color: tab.active ? brandColor : "tw-neutral-600",
                        }}
                      />
                      {tab.badge && (
                        <div className="tw-absolute -tw-top-1 -tw-right-1 tw-w-4 tw-h-4 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-medium tw-bg-neutral-600 tw-text-white">
                          {tab.badge}
                        </div>
                      )}
                    </div>
                    <span
                      className="tw-text-xs tw-font-medium tw-text-neutral-600"
                      style={{
                        color: tab.active ? brandColor : "tw-neutral-600",
                      }}
                    >
                      {tab.name}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Home Indicator */}
        <div className="tw-absolute tw-bottom-2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw-w-32 tw-h-1 tw-bg-gray-300 tw-rounded-full"></div>
      </div>
    </div>
  );
};

export default MobileFrame;
